import React from 'react';

export default function MerchantFee() {
    const methods = [
        { title: 'Web-Payment', icon: require('../../../assets/Icons/webPayments.png'), stripe: '2.9% + 0.30 cents', iashine: '0.3% + 0.30 cents' },
        { title: 'Terminal', icon: require('../../../assets/Icons/terminal.png'), stripe: '2.7% + 0.05 cents', iashine: '0.4% + 0.40 cents' },
        { title: 'AID-Pay (CC)', icon: require('../../../assets/Icons/cc.png'), stripe: '2.9% + 0.30 cents', iashine: '0.3% + 0.30 cents' },
        { title: 'AID-Pay (ACH) < $625.00', icon: require('../../../assets/Icons/ach.png'), stripe: '0.8% + 0 cents', iashine: '0.5% + 0 cents' },
        { title: 'AID-Pay (ACH) ≥ $625.00', icon: require('../../../assets/Icons/ach.png'), stripe: '0% + $5', iashine: '0% + $3' }
    ];


    return (
        <div style={styles.container}>
            <h1 style={styles.title}>Merchant Fee</h1>

            <div style={styles.grid}>
                {methods.map((m, idx) => (
                    <div key={idx} style={styles.card}>
                        <div style={styles.cardHeader}>
                            <span className="material-icons" style={styles.icon}>
                                <img src={m.icon} alt="AID" />
                            </span>
                            <span style={styles.methodTitle}>{m.title}</span>
                        </div>
                        <hr style={styles.divider} />
                        <div style={styles.feeRow}>
                            <div style={styles.feeItem}>
                                <div style={styles.cardLable}>
                                    <span className="material-icons" style={styles.check}>check_circle</span>
                                    <span style={styles.feeLabel}>Stripe Fees</span>
                                </div>
                                <span style={styles.feeValue}>{m.stripe}</span>
                            </div>
                            <div style={styles.feeItem}>
                                <div style={styles.cardLable}>
                                    <span className="material-icons" style={styles.check}>check_circle</span>
                                    <span style={styles.feeLabel}>Iashine Fees</span>
                                </div>
                                <span style={styles.feeValue}>{m.iashine}</span>
                            </div>
                        </div>
                    </div>
                ))}


            </div>
        </div>
    );
}

const styles = {
    container: { margin: '0 auto',  color: '#333' },
    title: { fontSize: 24, marginBottom: 16, marginTop: 0, color: '#4a5568' },
    grid: {
        gap: 30,
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        maxWidth: '70%',
    },
    card: {
        background: '#fff',
        borderRadius: 8,
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        padding: 16,
        display: 'flex',
        flexDirection: 'column',
        width: 500
    },
    largeCard: {
        gridColumn: 'span 2'
    },
    cardHeader: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: 8
    },
    icon: {
        fontSize: 24,
        color: '#7c4dff',
        marginRight: 8
    },
    methodTitle: {
        fontSize: '20px',
        fontWeight: '500'
    },
    divider: {
        border: 'none',
        borderTop: '1px solid #e0e0e0',
        margin: '8px 0'
    },
    feeRow: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: 8,
        padding: '14px 0px'
    },
    feeItem: {
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center'
    },
    check: {
        color: '#7c4dff',
        marginBottom: 4
    },
    feeLabel: {
        fontSize: 14,
        marginBottom: 4
    },
    feeValue: {
        fontSize: 14,
        fontWeight: 'bold',
        paddingLeft: '30px',
    },
    cardLable: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        flexWrap: 'nowrap',
        gap: '8px'
    }

};
